(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ae-homepage"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ae-home-logo-ribbon')) customElements.define('ae-home-logo-ribbon', class extends HTMLElement {
 connectedCallback(){if(this.ready)return;this.ready=true;const button=this.querySelector('[data-home-logo-pause]');if(!button)return;button.addEventListener('click',()=>{const paused=this.classList.toggle('is-paused');button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'Resume logos':'Pause logos';});}
});

if (!customElements.get('ae-homepage')) {
  customElements.define('ae-homepage', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const decorativeRows = this.querySelectorAll('.ae-origin-row');
      if ('IntersectionObserver' in window) {
        const decorativeObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('ae-decor-ready');
            decorativeObserver.unobserve(entry.target);
          });
        }, { rootMargin: '800px 0px' });
        decorativeRows.forEach(row => decorativeObserver.observe(row));
      } else {
        decorativeRows.forEach(row => row.classList.add('ae-decor-ready'));
      }


      const counters = this.querySelectorAll('[data-ae-count-to]');
      if (counters.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const countObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const counter = entry.target;
            countObserver.unobserve(counter);
            const target = Number(counter.dataset.aeCountTo);
            const duration = Number(counter.dataset.aeCountDuration) || 5000;
            const started = performance.now();
            counter.textContent = '0';
            const tick = now => {
              const progress = Math.min(1, (now - started) / duration);
              const eased = (1 - Math.cos(Math.PI * progress)) / 2;
              counter.textContent = String(Math.min(target, Math.floor(target * eased)));
              if (progress < 1) requestAnimationFrame(tick);
              else counter.textContent = String(target);
            };
            requestAnimationFrame(tick);
          });
        }, {threshold:0.6});
        counters.forEach(counter => countObserver.observe(counter));
      }

      const features = this.querySelector('.ae-feature-band');
      if (features && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const featureObserver = new IntersectionObserver((entries) => {
          if (entries.some(entry => entry.isIntersecting)) {
            features.classList.add('ae-inview');
            featureObserver.disconnect();
          }
        }, { threshold: 0.12 });
        features.classList.add('ae-motion-ready');
        featureObserver.observe(features);
      }
      const video = this.querySelector('.ae-home-film');
      if (!video) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let filmLoaded = false;
      let openingReady = false;
      let filmInView = true;
      let userPaused = false;
      const filmControl = this.querySelector('[data-ae-film-control]');
      const syncFilm = () => {
        if (!openingReady || !filmInView || userPaused || document.hidden || reducedMotion.matches || navigator.connection?.saveData) {
          video.pause();
          return;
        }
        if (!filmLoaded) {
          filmLoaded = true;
          const mobileFilm = window.matchMedia('(max-width: 749px)').matches;
          video.src = mobileFilm ? (video.dataset.mobileFilmSource || video.dataset.filmSource) : video.dataset.filmSource;
          video.load();
        }
        video.play().catch(() => {});
      };
      video.addEventListener('playing', () => {
        video.classList.add('is-playing');
        if (filmControl) {
          filmControl.hidden = false;
          filmControl.textContent = filmControl.dataset.pause;
          filmControl.setAttribute('aria-pressed', 'false');
        }
      });
      video.addEventListener('pause', () => {
        if (filmControl && !filmControl.hidden) {
          filmControl.textContent = filmControl.dataset.play;
          filmControl.setAttribute('aria-pressed', 'true');
        }
      });
      filmControl?.addEventListener('click', () => {
        userPaused = !userPaused;
        syncFilm();
      });
      if ('IntersectionObserver' in window) {
        const filmObserver = new IntersectionObserver(entries => {
          filmInView = entries.some(entry => entry.isIntersecting);
          syncFilm();
        }, { threshold: 0.01 });
        filmObserver.observe(video.parentElement);
      }
      document.addEventListener('visibilitychange', syncFilm);
      reducedMotion.addEventListener?.('change', syncFilm);
      const startAfterOpening = () => {
        const poster = this.querySelector('.ae-home-poster');
        const ready = poster && !poster.complete ? new Promise(resolve => {
          poster.addEventListener('load', resolve, { once: true });
          poster.addEventListener('error', resolve, { once: true });
        }) : Promise.resolve();
        ready.then(() => poster?.decode?.().catch(() => {})).then(() => {
          requestAnimationFrame(() => requestAnimationFrame(() => {
            const startFilm = () => {
              openingReady = true;
              syncFilm();
            };
            if ('requestIdleCallback' in window) window.requestIdleCallback(startFilm, { timeout: 2000 });
            else window.setTimeout(startFilm, 200);
          }));
        });
      };
      if (document.readyState === 'complete') startAfterOpening();
      else window.addEventListener('load', startAfterOpening, { once: true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ae-information"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ae-logo-ribbon'))customElements.define('ae-logo-ribbon',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const button=this.querySelector('[data-logo-pause]');if(!button)return;button.addEventListener('click',()=>{const paused=this.classList.toggle('is-paused');button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'Resume logos':'Pause logos';});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ae-native-footer"]) return;
  try {
    
if(!customElements.get('ae-native-footer'))customElements.define('ae-native-footer',class extends HTMLElement{connectedCallback(){this.media=window.matchMedia('(min-width:750px)');this.sync=()=>this.querySelectorAll('.ae-native-footer-panel').forEach(panel=>panel.open=this.media.matches);this.sync();this.media.addEventListener('change',this.sync)}disconnectedCallback(){this.media?.removeEventListener('change',this.sync)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ae-shop-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ae-shop-product')) customElements.define('ae-shop-product', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const select = this.querySelector('[data-ae-variant]');
    const image = this.querySelector('.ae-gallery-current');
    const thumbnails = [...this.querySelectorAll('[data-ae-picture]')];
    const setImage = (url, alt) => {
      if (!url || !image) return;
      image.removeAttribute('srcset');
      image.src = url;
      if (alt) image.alt = alt;
    };
    const markImage = selected => thumbnails.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
    thumbnails.forEach(button => button.addEventListener('click', () => {
      const variantId = button.dataset.aePictureVariant;
      if (variantId && select && select.value !== variantId) {
        select.value = variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      setImage(button.dataset.aePicture, button.dataset.aeAlt);
      markImage(button);
    }));
    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const add = this.querySelector('[data-ae-add]');
      const nextPrice = document.createElement('span');
      nextPrice.className = 'money';
      nextPrice.setAttribute('data-ae-price', '');
      nextPrice.textContent = option.dataset.price;
      this.querySelector('[data-ae-price]').replaceWith(nextPrice);
      const term = this.querySelector('[data-ae-term]');
      const deposit = this.querySelector('[data-ae-deposit]');
      if (term) term.textContent = option.dataset.title;
      if (deposit) deposit.textContent = option.dataset.deposit;
      add.disabled = option.dataset.available !== 'true';
      add.firstChild.textContent = (add.disabled ? add.dataset.soldOut : add.dataset.label) + ' ';
      this.querySelectorAll('[data-ae-note]').forEach(note => note.hidden = note.dataset.aeNote !== select.value);
      const thumbnail = thumbnails.find(button => button.dataset.aePictureVariant === select.value)
        || thumbnails.find(button => button.dataset.aePicture === option.dataset.image);
      setImage(option.dataset.image, thumbnail?.dataset.aeAlt);
      if (option.dataset.image) markImage(thumbnail);
      const url = new URL(location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState({}, '', url);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class AEAccordionNavigation extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('pointerover', (event) => {
        const toggle = event.target.closest('[data-ae-collection]');
        if (!toggle || !this.contains(toggle) || event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches || toggle.contains(event.relatedTarget)) return;
        clearTimeout(this.hoverTimer);
        this.hoverTimer = setTimeout(() => {
          this.querySelectorAll('[data-ae-accordion]').forEach(other => {
            if (other !== toggle) this.setExpanded(other, false);
          });
          this.setExpanded(toggle, true);
        }, 180);
      });
      this.addEventListener('pointerout', (event) => {
        const toggle = event.target.closest('[data-ae-collection]');
        if (toggle && !toggle.contains(event.relatedTarget)) clearTimeout(this.hoverTimer);
      });
      this.addEventListener('click', (event) => {
        clearTimeout(this.hoverTimer);
        const toggle = event.target.closest('[data-ae-accordion]');
        if (!toggle) return;
        event.preventDefault();
        event.stopPropagation();
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        this.querySelectorAll('[data-ae-accordion]').forEach((other) => {
          if (other !== toggle) this.setExpanded(other, false);
        });
        this.setExpanded(toggle, !expanded);
      }, true);
      this.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape') return;
        clearTimeout(this.hoverTimer);
        const group = event.target.closest('[data-ae-group]');
        const toggle = group && group.querySelector('[data-ae-accordion]');
        if (!toggle || toggle.getAttribute('aria-expanded') !== 'true') return;
        event.preventDefault();
        event.stopPropagation();
        this.setExpanded(toggle, false);
        toggle.focus({ preventScroll: true });
      }, true);
    }

    disconnectedCallback() {
      clearTimeout(this.hoverTimer);
    }

    setExpanded(toggle, expanded) {
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel || !this.contains(panel)) return;
      toggle.setAttribute('aria-expanded', String(expanded));
      panel.hidden = !expanded;
    }
  }

  if (!customElements.get('ae-accordion-navigation')) {
    customElements.define('ae-accordion-navigation', AEAccordionNavigation);
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.headerHeight = 0;
      this.headerMedia = window.matchMedia('(max-width: 990px)');
      this.onHeaderBreakpoint = () => {
        cancelAnimationFrame(this.headerHeightFrame);
        this.headerHeightFrame = requestAnimationFrame(() => this.setHeaderHeight());
      };
      if ('ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver(entries => {
          const box = entries[0].borderBoxSize;
          const height = box ? (box[0] || box).blockSize : this.header.getBoundingClientRect().height;
          cancelAnimationFrame(this.headerHeightFrame);
          this.headerHeightFrame = requestAnimationFrame(() => this.setHeaderHeight(height));
        });
        this.headerResizeObserver.observe(this.header);
      } else {
        this.onHeaderBreakpoint();
        this.headerMedia.addEventListener('change', this.onHeaderBreakpoint);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight(measuredHeight) {
      const height = Math.ceil(measuredHeight ?? this.header.offsetHeight);
      if (height === this.headerHeight) return;
      this.headerHeight = height;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver?.disconnect();
      this.headerMedia?.removeEventListener('change', this.onHeaderBreakpoint);
      cancelAnimationFrame(this.headerHeightFrame);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
